import { Scenarios } from '@jfs/network'

export const agentUserInformation = {
  default: [
    {
      url: /aepsAgent\/getAgentUserInformation/,
      method: 'GET',
      response: {
        agentUserLoginId: '2000001533',
        agentUserName: 'Harshit Agrawal',
        gender: 10,
        dob: '25-06-1989',
        parentOnboardingId: '2000001100',
        agentMobileNumber: '9765051530',
        agentEmailId: null,
        mobileCountryCode: 91,
        agentStatus: 10,
        agentEKYCStatus: false,
        agentUserStateCode: null,
        agentUserCity: null,
        agentUserPincode: null,
        accountBalance: null,
        accountBalanceDate: null,
        agentUserRoleType: 0,
        agentUserDealershipName: 'Reliance Root',
        agentUserDealerCity: 'MUMBAI',
        agentUserDealerState: 'MH',
        agentUserDealerPinCode: '400701',
        agentUserDealerStoreCode: 'modified123454',
        agentAuthorization: null,
        aadhaar: {
          tokenPresent: true,
          token: '01001255mPFhDw9sohH+zuB7be4QISSQof/fjtV3a2xKTAOOYp5n0sLp2+pJ0ANiYxFxfkcs',
          maskedValue: '********5464',
        },
        adminUser: false,
      },
      delay: 500,
    },
  ],
  failed: [
    {
      url: /agent\/getAgentUserInformation/,
      method: 'GET',
      responseCode: 500,
      response: { error: { code: 416, message: 'Invalid request' } },
      delay: 1000,
    },
  ],
} as Scenarios
